import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTaxes } from "../../reduxStore/slices/itemSlice";
import { useNotify } from "../../utils/snackbarUtils";

const ItemTaxes = ({ taxes, setTaxes }) => {
  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const storeId = user?.storeId;

  // Local state for GST settings
  const [allTaxes, setAllTaxes] = useState([]);
  const [priceIncludesGST, setPriceIncludesGST] = useState(
    taxes?.taxUid ? false : true
  );

  const getAllTaxes = async () => {
    try {
      const allTax = await dispatch(getTaxes({ storeId })).unwrap();
      setAllTaxes(allTax.tax || []);
    } catch (err) {
      handleApiError(err);
    }
  };

  useEffect(() => {
    if (storeId) {
      getAllTaxes();
    }
  }, [storeId]);

  const handleTaxChange = (e) => {
    setTaxes((prevTaxes) => ({
      ...prevTaxes,
      taxUid: e.target.value,
    }));
  };

  const handleHSNCodeChange = (e) => {
    setTaxes((prevTaxes) => ({
      ...prevTaxes,
      hsnCode: e.target.value,
    }));
  };

  const handleToggleChange = (e) => {
    const isChecked = e.target.checked;
    setPriceIncludesGST(isChecked);
    setTaxes((prevTaxes) => ({
      ...prevTaxes,
      taxUid: isChecked ? null : prevTaxes.taxUid,
    }));
  };

  return (
    <Box sx={{ paddingX: 2, paddingY: 1 }}>
      <Stack spacing={3}>
        {/* Price includes taxes toggle */}
        <FormControlLabel
          control={
            <Switch checked={priceIncludesGST} onChange={handleToggleChange} />
          }
          label="Price includes taxes"
        />

        {/* Show GST config only if toggle is OFF */}
        {!priceIncludesGST && (
          <Stack spacing={3}>
            {/* GST Rate Dropdown */}
            <FormControl fullWidth>
              <InputLabel id="gst-rate-label">GST Rate *</InputLabel>
              <Select
                labelId="gst-rate-label"
                value={taxes?.taxUid || ""}
                label="GST Rate *"
                onChange={handleTaxChange}
              >
                {allTaxes.map((tax) => (
                  <MenuItem key={tax.uid} value={tax.uid}>
                    {tax.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        )}
        <Box>
          {/* HSN / SAC Code */}
          <TextField
            label="HSN / SAC Code (Optional)"
            value={taxes?.hsnCode || ""}
            onChange={handleHSNCodeChange}
            helperText="Used for GST compliance and reporting"
            fullWidth
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default ItemTaxes;
